export const CanonicalStableIdStorageKey = 'anagram-stable-id'
export const LegacyShopperIdStorageKey = 'AnagramShopperId'

export function normalizeStableId(value: unknown): string | null {
  if (typeof value !== 'string') return null

  const trimmed = value.trim()
  if (!trimmed) return null
  if (trimmed.toLowerCase() === 'anonymous') return null

  return trimmed
}

export function isValidStableId(value: unknown): value is string {
  return normalizeStableId(value) !== null
}
